import React from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorBoundary } from 'react-error-boundary'
import { HeaderWidget as HeaderWidgetType } from 'schemas/HeaderWidgetSchema'
import { Widget } from 'features/types'
import { useDisplayTheme } from '../../../hooks/useUiState'
import { useDashboardWidgetSetting } from '../../../hooks/useDashboardState'
import PlaceHolder from '../../share/PlaceHolder'
import StyledHeaderWidget from './index.css'

const HeaderWidget: Widget = ({ widgetId }) => {
  const theme = useDisplayTheme()
  const { t } = useTranslation()
  const widgetSetting = useDashboardWidgetSetting<HeaderWidgetType>(widgetId)

  const headerContent = widgetSetting.text ? widgetSetting.text : t('headerPlaceholder')

  return (
    <ErrorBoundary FallbackComponent={({ error }) => <PlaceHolder>{error.message}</PlaceHolder>}>
      <StyledHeaderWidget displayTheme={theme}>{headerContent}</StyledHeaderWidget>
    </ErrorBoundary>
  )
}

export default HeaderWidget
